<form method="post" enctype="multipart/form-data">
  <div *ngIf="isPrefixMisMatch" class="error-text">
    {{'PREFIX_MISMATCH_MESSAGE'| translate: {filePrefix: filePrefix} }}
  </div>
  <div *ngIf="isPrefixExactMatch" class="error-text">
    {{'PREFIX_EXACT_MATCH_MESSAGE'| translate: {fileName: fileName,filePrefix: filePrefix} }}
  </div>
  <div *ngIf="isEmptyFilename" class="error-text">
    {{'FILE_NAME_IS_EMPTY'| translate }}
  </div>
  <div *ngIf="isInvalidFormat" class="error-text">
    {{'CSV_FILES_ALLOWED'| translate }}
  </div>
  <label class="file-uploader" for="file">
    <i class="icon ftmi-file text-primary"></i>
    <label class="title" [ngClass]="cssClass" for="file"> {{ this.file?.name || 'SELECT_FILE_TO_UPLOAD' | translate }} </label>
    <input id="file" type="file" class="d-none" (change)="onFileChange($event)" />
  </label>
</form>